export interface StructuralWidgetProps {
  config?: Readonly<Record<string, unknown>>;
}

export function getWidgetConfigString(
  config: Readonly<Record<string, unknown>> | undefined,
  key: string,
  fallback: string,
) {
  const value = config?.[key];
  return typeof value === "string" && value.trim() ? value : fallback;
}
